var $00a415a3f0ab315a$exports = {};
$00a415a3f0ab315a$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "V\xE4rimuokkain",
  "colorSwatch": "v\xE4rimalli",
  "transparent": "l\xE4pin\xE4kyv\xE4",
  "twoDimensionalSlider": "2D-liukus\xE4\xE4din"
};
export { $00a415a3f0ab315a$exports as default };